module.exports = __webpack_public_path__ + "img/logo5.4bb48bae.png";